/**
 * Type definitions for the Page Builder data structure
 */

// Base widget interface that can be extended for specific widget types
export interface Widget {
	id: string;
	type: string;
	[key: string]: any; // Additional properties specific to each widget type
}

// Product interface
export interface Product {
	id: string;
	name: string;
	[key: string]: any; // Additional product properties
}

// Category interface
export interface Category {
	id: string;
	name: string;
	[key: string]: any; // Additional category properties
}

// Brand interface
export interface Brand {
	id: string;
	name: string;
	[key: string]: any; // Additional brand properties
}

// Campaign interface
export interface Campaign {
	id: string;
	name: string;
	[key: string]: any; // Additional campaign properties
}

// Page data structure
export interface PageData {
	_id: string;
	name: string;
	status: "draft" | "published" | "archived";
	widgets: Widget[];
	shopId: number;
	sidebar: any[];
	topbar: any[];
	type: "category" | "product" | "brand" | "landing" | "custom" | string;
	campaigns: Campaign[];
	categories: Category[];
	brands: Brand[];
	products: Product[];
	is_published_one: boolean;
	is_deletable: boolean;
	active: boolean;
	createdAt: string;
	updatedAt: string;
	__v: number;
}

// Page update options
export enum ImportOption {
	REPLACE = "replace",
	ADD = "add",
}

// Function to validate if a JSON object conforms to the PageData structure
export function isValidPageData(data: any): data is PageData {
	return (
		data &&
		typeof data._id === "string" &&
		typeof data.name === "string" &&
		Array.isArray(data.widgets)
	);
}
